<app-layout>
    <h3 class="text-center">Duyuru Gönder</h3>
    <div class="add-duyuru">
        <div class="row">
            <div class="col-12">
                <form action="#">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label"> Kullanıcı Grupları </label>
                            <select [(ngModel)] = "duyuru.kullaniciGrupId" [ngModelOptions]="{standalone: true}" class="form-control">
                                <option [value]="0" selected> Tüm kullanıcı grupları </option>
                                <option *ngFor="let item of kullaniciGrupList" [value]="item.id">{{item.isim}}</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Başlangıç Tarihi</label>
                            <input [(ngModel)]="duyuru.duyuruTarihi" [ngModelOptions]="{standalone: true}" type="date"
                                class="form-control" id="start-datetime">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Bitiş Tarihi</label>
                            <input [(ngModel)]="duyuru.duyuruBitisTarihi" [ngModelOptions]="{standalone: true}" type="date" class="form-control"
                                id="end-datetime">
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Başlık</label>
                        <input [(ngModel)]="duyuru.baslik" [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="title">
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Mesaj</label>
                        <textarea [(ngModel)]="duyuru.mesaj" [ngModelOptions]="{standalone: true}" class="form-control" id="message"></textarea>
                    </div>
                    <button type="button" class="btn btn-primary" (click)="addDuyuru()">Gönder</button>
                </form>
            </div>
        </div>
    </div>
</app-layout>